import React, { useEffect, useState, useRef } from 'react';
import Scheme_Sale_AFSO from './Scheme_Sale_AFSO';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

// const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const KeyRegisterAllotDist_data = async (params) => {

    const response = await fetch(`${process.env.REACT_APP_URL_SALE}/Sales/getScheme_Sale`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const Scheme_Sale_Dist = ({ month, year, allot_month, allot_year, comm_id, heading }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContentt, setRenderContentt] = useState(null);
    const [dataTime, setDataTime] = useState("");
    const detailsRRef = useRef(null); // Use ref to scroll to this div
    const [totals, setTotals] = useState([]); // State for storing column totals
    const [dist_code, setDist_code] = useState("");
    const [afso_code, setAfso_code] = useState("");

    const handleDistClick = (month, year, allot_month, allot_year, comm_id, dist_code, heading) => {

        setRenderContentt(null);
        setTimeout(() => {
            setRenderContentt(
                <Scheme_Sale_AFSO month={month} year={year} allot_month={allot_month} allot_year={allot_year} comm_id={comm_id} dist_code={dist_code} afso_code={afso_code} heading={heading} />
            );
        }, 10);
    };

    const calculateTotals = (data) => {
        const columnCount = data[0].c_lst.length * 4; // 4 columns per scheme
        const totals = new Array(columnCount).fill(0); // Initialize totals array with zeros
        const counts = new Array(columnCount).fill(0); // Initialize counts array for averages

        data.forEach((item) => {
            item.c_lst.forEach((colItem, colIndex) => {
                const baseIndex = colIndex * 4; // Each scheme has 4 columns

                totals[baseIndex] += parseInt(colItem.total_cards) || 0;
                totals[baseIndex + 1] += parseInt(colItem.avail_cards) || 0;
                totals[baseIndex + 2] += parseFloat(colItem.avail_qty) || 0;

                const totalValue = parseFloat(colItem.total_cards);
                const cardsValue = parseFloat(colItem.avail_cards);
                if (totalValue > 0 && cardsValue > 0) {
                    const availedPerValue = (cardsValue * 100) / totalValue;
                    totals[baseIndex + 3] += availedPerValue;
                    counts[baseIndex + 3] += 1;
                }

            });
        });

        counts.forEach((count, index) => {
            if (count > 0) {
                totals[index] = index % 4 === 3 ? totals[index] / count : totals[index]; // Only average `availed_per`
            }
        });

        setTotals(totals);
    };

    const exportToExcel = async () => {
        if (!reportData || reportData.length === 0) return;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Scheme Sale', {
            views: [{ showGridLines: true }]
        });

        const applyStyleToRange = (ws, startRow, startCol, endRow, endCol, styleFn) => {
            for (let r = startRow; r <= endRow; r++) {
                const row = ws.getRow(r);
                for (let c = startCol; c <= endCol; c++) {
                    styleFn(row.getCell(c));
                }
            }
        };

        const thinBorder = { style: 'thin', color: { argb: 'FF000000' } };
        const headerFill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFEFEFEF' }
        };

        const totalColumns = 2 + (reportData[0].c_lst.length * 4);

        worksheet.mergeCells(1, 1, 1, totalColumns);
        const titleCell = worksheet.getCell(1, 1);
        titleCell.value = tabHeading || 'Scheme Sale Status';
        titleCell.font = { bold: true, size: 14 };
        titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.getRow(1).height = 26;

        const row2 = ["Sl.No", "District", "Sale Qty in Kgs/Lts"];
        for (let i = 0; i < reportData[0].c_lst.length * 4 - 1; i++) {
            row2.push("");
        }
        worksheet.addRow(row2);

        const row3 = ["", ""];
        reportData[0].c_lst.forEach(scheme => {
            row3.push(scheme.scheme_short_name, "", "", "");
        });
        worksheet.addRow(row3);

        const row4 = ["", ""];
        reportData[0].c_lst.forEach(() => {
            row4.push("Total Cards", "Availed Cards", "Availed Qty (Kgs/Lts)", "Availed %");
        });
        worksheet.addRow(row4);

        worksheet.mergeCells('A2:A4');
        worksheet.mergeCells('B2:B4');
        worksheet.mergeCells(2, 3, 2, totalColumns);

        let currentCol = 3;
        reportData[0].c_lst.forEach(() => {
            worksheet.mergeCells(3, currentCol, 3, currentCol + 3);
            currentCol += 4;
        });

        applyStyleToRange(worksheet, 2, 1, 4, totalColumns, (cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.fill = headerFill;
            cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
        });

        worksheet.getRow(2).height = 20;
        worksheet.getRow(3).height = 20;
        worksheet.getRow(4).height = 30;

        reportData.forEach((row, index) => {
            const rowData = [
                index + 1,
                row.dist_name_en || ""
            ];

            row.c_lst.forEach(item => {
                rowData.push(
                    Number(item.total_cards || 0),
                    Number(item.avail_cards || 0),
                    Number(item.avail_qty || 0),
                    Number(item.availed_per || 0)
                );
            });

            const r = worksheet.addRow(rowData);

            r.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                if (colNumber === 2) {
                    cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
                } else {
                    cell.alignment = { horizontal: 'center', vertical: 'middle' };
                }
                if (colNumber >= 3) {
                    const mod = (colNumber - 3) % 4;
                    if (mod === 0 || mod === 1) {
                        cell.numFmt = '0';
                    } else {
                        cell.numFmt = '0.00';
                    }
                }
                cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
            });
        });

        const totalRowIndex = worksheet.lastRow.number + 1;
        const totalRowData = ["Total", ""];
        totals.forEach(total => {
            totalRowData.push(Number(total || 0));
        });

        worksheet.addRow(totalRowData);
        worksheet.mergeCells(totalRowIndex, 1, totalRowIndex, 2);
        applyStyleToRange(worksheet, totalRowIndex, 1, totalRowIndex, totalColumns, (cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
            if (cell._column && cell._column.number >= 3) {
                const mod = (cell._column.number - 3) % 4;
                if (mod === 0 || mod === 1) {
                    cell.numFmt = '0';
                } else {
                    cell.numFmt = '0.00';
                }
            }
        });

        if (dataTime) {
            const refreshRowIndex = worksheet.lastRow.number + 1;
            worksheet.addRow([`Last Refresh Time: ${dataTime}`]);
            worksheet.mergeCells(refreshRowIndex, 1, refreshRowIndex, totalColumns);
            const refreshCell = worksheet.getCell(refreshRowIndex, 1);
            refreshCell.font = { bold: true };
            refreshCell.alignment = { horizontal: 'right', vertical: 'middle' };
            refreshCell.border = { top: thinBorder, left: thinBorder, bottom: thinBorder, right: thinBorder };
        }

        worksheet.getColumn(1).width = 8;
        worksheet.getColumn(2).width = 22;
        for (let c = 3; c <= totalColumns; c++) {
            worksheet.getColumn(c).width = 15;
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Scheme_Sale_Dist_${month}_${year}.xlsx`);
    };

    useEffect(() => {

        const getData = async () => {
            try {

                const response_data = await KeyRegisterAllotDist_data({
                    month, year, allot_month, allot_year, comm_id, dist_code, afso_code
                });

                setTabHeading(response_data?.heading || "");

                const data = response_data?.data || [];

                setReportData(data);

                if (data.length > 0) {
                    const dTimeItem = data.find(item => item.data_time || item.DATA_TIME);
                    let dTime = dTimeItem ? (dTimeItem.data_time || dTimeItem.DATA_TIME) : "";
                    if (dTime) {
                        try {
                            const date = new Date(dTime);
                            const day = String(date.getDate()).padStart(2, '0');
                            const monthVal = String(date.getMonth() + 1).padStart(2, '0');
                            const yearVal = date.getFullYear();
                            let hours = date.getHours();
                            const minutes = String(date.getMinutes()).padStart(2, '0');
                            const seconds = String(date.getSeconds()).padStart(2, '0');
                            const ampm = hours >= 12 ? 'PM' : 'AM';
                            hours = hours % 12 || 12;
                            const strHours = String(hours).padStart(2, '0');
                            dTime = `${day}-${monthVal}-${yearVal} ${strHours}:${minutes}:${seconds} ${ampm}`;
                        } catch (e) {
                            dTime = dTime.replace('T', ' ').substring(0, 19);
                        }
                    }
                    setDataTime(dTime);
                    calculateTotals(data);
                }

            } catch (error) {
                setError(error);
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year, allot_month, allot_year, comm_id, dist_code, afso_code]);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
            detailsRRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [loading, error, reportData]);

    if (loading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Box sx={{ display: 'flex' }}>
            <CircularProgress />
        </Box></div>
    }
    if (error) {
        return <div className="mainhead" align="center">
            Internal Error
        </div>
    }

    if (reportData.length === 0) {
        return <div className="mainhead" align="center">
            No data found
        </div>
    }

    return (
        <>
            <div style={{ overflowX: 'auto', width: '100%', margin: '0 auto' }}>
                <table align="center" width="100%" border={1}>
                    <thead>
                        <tr className="tableheader">
                            <th colSpan={2 + ((reportData[0].c_lst.length) * 4)}>{tabHeading}</th>
                        </tr>
                        <tr className="tableheader">
                            <th rowSpan={3}>Sl.No</th>
                            <th rowSpan={3}>District</th>
                            <th colspan={(reportData[0].c_lst.length) * 4}>Sale Qty in Kgs/Lts</th>
                            {/* <th colspan={4} rowSpan={2}>Total</th> */}
                        </tr>
                        <tr className="tableheader">
                            {reportData[0].c_lst.map((items) => (
                                <th colSpan={4} rowSpan={1}>{items.scheme_short_name}</th>
                            ))}

                        </tr>

                        <tr className="tableheader">
                            {reportData[0].c_lst.map(() => (
                                <>
                                    <th rowSpan={1}>Total<br />Cards</th>
                                    <th rowSpan={1}>Availed<br />Cards</th>
                                    <th rowSpan={1}>Availed<br />Qty<br />(Kgs/Lts)</th>
                                    <th rowSpan={1}>Availed<br />%</th>
                                </>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            reportData.map((item, index) => (

                                <tr key={item.dist_code}>
                                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                    <td style={{ textAlign: 'left' }}>
                                        <a style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={() => handleDistClick(month, year, allot_month, allot_year, comm_id, item.dist_code, tabHeading)}  >
                                            {item.dist_name_en}
                                        </a>
                                    </td>
                                    {item.c_lst.map((item1, index) => (
                                        <>
                                            <td style={{ textAlign: 'right' }} >{item1.total_cards}</td>
                                            <td style={{ textAlign: 'right' }} >{item1.avail_cards}</td>
                                            <td style={{ textAlign: 'right' }}  >{item1.avail_qty.toFixed(2)}</td>
                                            <td style={{ textAlign: 'right' }}  >{item1.availed_per.toFixed(2)}</td>
                                        </>
                                    ))}

                                </tr>
                            ))
                        }
                        <tr className="tableheader">
                            <td colSpan={2} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</td>
                            {totals.map((total, index) => (
                                <td style={{ textAlign: 'right', fontWeight: 'bold' }} key={index}>{total.toFixed(2)}</td>
                            ))}

                        </tr>

                        <tr align="center">
                            <td colSpan={2 + (reportData[0].c_lst.length * 4)}>
                                <button className="button button2" onClick={exportToExcel}>Export to Excel</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {dataTime && (
                <div style={{ textAlign: 'right', width: '100%', margin: '10px auto 0', fontWeight: 'bold' }}>
                    Last Refresh Time: {dataTime}
                </div>
            )}
            <br /><br />
            <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>
        </>
    );
};

export default Scheme_Sale_Dist;
